const calendarStyledCompCalendar = {
  culture: 'en'
};

export default calendarStyledCompCalendar